import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Landing from "@/pages/landing";

// Base path for GitHub Pages (e.g. /sunshine/) or "/" for local / custom domain
const basePath = (import.meta.env.BASE_URL || "/").replace(/\/$/, "") || "";

function Router() {
  return (
    <Switch>
      {basePath ? <Route path={`${basePath}/`} component={Landing} /> : null}
      <Route path={basePath || "/"} component={Landing} />
      <Route path={`${basePath}/*`} component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
